import { createSlice } from "@reduxjs/toolkit";
import { sagaActions } from "../sagas/sagaActions";

const initialState = {
  contacts: {},
};

export const contactsSlice = createSlice({
  name: "contacts",
  initialState,
  extraReducers: (builder) => {
    builder.addCase(sagaActions.CONTACTS_LOAD, (state, action) => {
      state.contacts = action.data;
    });
  },
});

export default contactsSlice.reducer;
